/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessPermission } from './BusinessPermission';
import {
    BusinessPermissionFromJSON,
    BusinessPermissionFromJSONTyped,
    BusinessPermissionToJSON,
    BusinessPermissionToJSONTyped,
} from './BusinessPermission';

/**
 * Represents detailed information about a business user.
 * @export
 * @interface BusinessUserFull
 */
export interface BusinessUserFull {
    /**
     * 
     * @type {string}
     * @memberof BusinessUserFull
     */
    user: string;
    /**
     * 
     * @type {Array<BusinessPermission>}
     * @memberof BusinessUserFull
     */
    permissions: Array<BusinessPermission>;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserFull
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserFull
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserFull
     */
    lastName: string;
}

/**
 * Check if a given object implements the BusinessUserFull interface.
 */
export function instanceOfBusinessUserFull(value: object): value is BusinessUserFull {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function BusinessUserFullFromJSON(json: any): BusinessUserFull {
    return BusinessUserFullFromJSONTyped(json, false);
}

export function BusinessUserFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUserFull {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'],
        'permissions': ((json['permissions'] as Array<any>).map(BusinessPermissionFromJSON)),
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function BusinessUserFullToJSON(json: any): BusinessUserFull {
    return BusinessUserFullToJSONTyped(json, false);
}

export function BusinessUserFullToJSONTyped(value?: BusinessUserFull | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': value['user'],
        'permissions': ((value['permissions'] as Array<any>).map(BusinessPermissionToJSON)),
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

